










































import Vue from 'vue';
import axios from '@/plugins/axios';
import CtrlNumTxt from '@/components/common/control/CtrlNumTxt.vue';
import CtrlSearchBtn from '@/components/common/control/CtrlSearchBtn.vue';
import ListJigyoshoGinko from '@/components/common/search/ListJigyoshoGinko.vue';
import { API_SEARCH_JIGYOSHO_GINKO } from '@/constants/api';
import { noDataError, clearNoDataError } from '@/utils/message';

export default Vue.extend<any, any, any, any>({
  name: 'CtrlJigyoshoGinko',
  components: {
    CtrlNumTxt,
    CtrlSearchBtn,
    ListJigyoshoGinko,
  },
  props: {
    jigyoshoCd: {
      type: Number,
      default: 0,
    },
    callbackCancel: {
      type: Function,
    },
    callbackOk: {
      type: Function,
    },
    label: {
      type: String,
      default: '事業所銀行',
    },
    widthCd: {
      type: Number,
      default: 99, //21,
    },
    widthName: {
      type: Number,
      default: 517,
    },
    required: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    mukoUmuFlg: {
      type: Number,
    },
  },
  data: () => ({
    API_SEARCH_JIGYOSHO_GINKO,
    listJigyoshoGinkoGinkoShow: false,
    sentakuGinkoCd: 0,
    ginkoMei: '',
    ginkoShitenMei: '',
    errors: {
      errorMessages: '',
    },
    isNoData: false,
  }),
  computed: {
    styleItemName() {
      return {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: `${this.widthName}px`,
        minWidth: `${this.widthName}px`,
        maxWidth: `${this.widthName}px`,
        color: 'rgba(0, 0, 0, 0.87)',
        cursor: 'default',
      };
    },
  },
  methods: {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleOk(item: any) {
      const { sentakuGinkoCd, ginkoMei, ginkoShitenMei } = item;
      this.sentakuGinkoCd = sentakuGinkoCd;
      this.ginkoMei = ginkoMei;
      this.ginkoShitenMei = ginkoShitenMei;
      this.listJigyoshoGinkoGinkoShow = false;
      this.errors.errorMessages = '';
      this.callbackOk && this.callbackOk(item);
      this.isNoData = false;
    },
    handleCancel() {
      this.listJigyoshoGinkoGinkoShow = false;
      this.callbackCancel && this.callbackCancel();
    },
    handleChange(value: number) {
      this.sentakuGinkoCd = value;
      if (value) {
        this.getJigyoshoGinkoItem();
      } else {
        this.ginkoMei = '';
        this.ginkoShitenMei = '';
        this.errors = clearNoDataError();
        // IDをクリアするとデータをリセットする
        this.callbackOk &&
          this.callbackOk({ sentakuGinkoCd: this.sentakuGinkoCd });
      }
    },
    getJigyoshoGinkoItem() {
      axios
        .get(API_SEARCH_JIGYOSHO_GINKO, {
          params: {
            jigyoshoCd: this.jigyoshoCd,
            sentakuGinkoCd: this.sentakuGinkoCd,
            mukoUmuFlg: this.mukoUmuFlg,
          },
        })
        .then((res) => {
          if (!res.data.responseData || res.data.responseData.length === 0) {
            this.ginkoMei = '';
            this.isNoData = true;
            this.errors = noDataError();
            this.callbackOk &&
              this.callbackOk({ sentakuGinkoCd: this.sentakuGinkoCd });
            return;
          }
          this.errors = clearNoDataError();
          const { ginkoMei, ginkoShitenMei } = res.data.responseData[0];
          this.ginkoMei = ginkoMei;
          this.ginkoShitenMei = ginkoShitenMei;
          this.callbackOk && this.callbackOk(res.data.responseData[0]);
          this.isNoData = false;
        });
    },
  },
  watch: {
    // 呼び出し元の tag の 引数 [sentakuGinkoCd] に bind している変数 を監視する
    // 変数が、input 以外の event で値変更された時に、その値を control に set
    '$attrs.sentakuGinkoCd': {
      handler(newValue) {
        if (+newValue === +this.sentakuGinkoCd) return;
        this.sentakuGinkoCd = +newValue;
        if (newValue) {
          this.getJigyoshoGinkoItem();
        } else {
          this.ginkoMei = '';
          this.errors = clearNoDataError();
        }
      },
    },
  },
  created() {
    if (this.$attrs.sentakuGinkoCd) {
      this.sentakuGinkoCd = +this.$attrs.sentakuGinkoCd;
    }
  },
});
